import { PeopleAlt, Settings, Dashboard } from "@mui/icons-material";
import { Icon } from "@mui/material";
import { settings_icon, patient_icon } from "assets/icons/aside-icons";
import { SvgToMuiIcon } from "./Icon_helper";
import {
  DashboardIcon,
  PatientIcon,
  SettingIcon,
  StoreIcon,
  TemplateIcon,
} from "assets/icons/NavIcons";
import SummarizeIcon from '@mui/icons-material/Summarize';
import EditNoteIcon from '@mui/icons-material/EditNote';

export const HOME = "HOME";
export const APPOINTMENTS = "APPOINTMENTS";
export const EHR = "EHR";
export const VITALS = "VITALS";
export const DOCUMENTS = "DOCUMENTS";
export const TASKS = "TASKS";
export const PATIENT = "PATIENTS";
export const TEMPLATES = "TEMPLATES";
export const RATING_SCALES = 'FORM';
export const CUSTOM_FORMS = 'CUSTOMFORMS'
export const INTAKE_FORMS = 'INTAKE'
export const SETTINGS = "SETTINGS";
export const STORE = "STORE";
export const ME = "ME";

export const ROUTER_OBJECT = [
  {
    label: "Dashboard",
    Icon: DashboardIcon,
    identifier: HOME,
    path: "/home/dashboard",
    className: "step-1 step-10",
  },
  {
    label: "Patients",
    // Icon: SvgToMuiIcon(patient_icon),
    Icon: PatientIcon,
    identifier: PATIENT,
    path: "/patients/list",
    className: "step-2",
  },
  {
    label: "Store",
    // Icon: SvgToMuiIcon(settings_icon),
    Icon: StoreIcon,
    identifier: STORE,
    path: "/store/plans",
    // className: "step-3",
  },
  // {
  //   label: "Intake-forms",
  //   Icon: EditNoteIcon,
  //   identifier: INTAKE_FORMS,
  //   path: "/intake",
  // },
  // {
  //   label: "Custom-forms",
  //   Icon: TemplateIcon,
  //   identifier: CUSTOM_FORMS,
  //   path: "/customForms",
  // },
  // {
  //   label: "Templates",
  //   Icon: TemplateIcon,
  //   identifier: TEMPLATES,
  //   path: "/templates",
  // },
  // {

  //   label: "Form-Scales",
  //   Icon: SummarizeIcon,
  //   identifier: RATING_SCALES,
  //   path: "/form",
  // },
  {
    label: "Settings",
    // Icon: SvgToMuiIcon(settings_icon),
    Icon: SettingIcon,
    identifier: SETTINGS,
    path: "/settings/me",
    // className: "step-3",
  },
  //   {
  //     label: "tooltips.APPOINTMENTS",
  //     Icon: CalendarMonth,
  //     identifier: APPOINTMENTS,
  //     // path: '/appointments/upcoming',
  //     path: "/appointments/recent",
  //     className: "step-3",
  //   },
  //   {
  //     label: "tooltips.EHR",
  //     Icon: AddCircle,
  //     identifier: EHR,
  //     path: "/ehr/personal_info",
  //     className: "step-4",
  //   },
  //   {
  //     label: "ehr.tabs.VITALS",
  //     Icon: MonitorHeart,
  //     identifier: VITALS,
  //     path: "/vitals/view",
  //     className: "step-5",
  //   },
  //   {
  //     label: "documents.DOCUMENTS",
  //     Icon: Description,
  //     identifier: DOCUMENTS,
  //     path: "/documents/view",
  //     className: "step-6",
  //   },
  //   {
  //     label: "tasks.TASKS",
  //     Icon: AssignmentTurnedIn,
  //     identifier: TASKS,
  //     path: "/tasks/requested",
  //     className: "step-7",
  //   },
];

export const getPathNames = () => {
  return window.location.pathname.split("/");
};
